import type React from 'react'

type Props = {
  className?: string
  width?: number
  height?: number
}

export const ContentSheet: React.FC<Props> = ({
  className,
  width = 80,
  height = 43,
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 80 43"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_60810_153580)">
        <path
          d="M12 12.8C12 11.1198 12 10.2798 12.327 9.63803C12.6146 9.07354 13.0735 8.6146 13.638 8.32698C14.2798 8 15.1198 8 16.8 8H63.2C64.8802 8 65.7202 8 66.362 8.32698C66.9265 8.6146 67.3854 9.07354 67.673 9.63803C68 10.2798 68 11.1198 68 12.8V76.2C68 77.8801 68 78.7202 67.673 79.362C67.3854 79.9265 66.9265 80.3854 66.362 80.673C65.7202 81 64.8802 81 63.2 81H16.8C15.1198 81 14.2798 81 13.638 80.673C13.0735 80.3854 12.6146 79.9265 12.327 79.362C12 78.7202 12 77.8802 12 76.2V12.8Z"
          fill="white"
        />
        <g clipPath="url(#clip1_60810_153580)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M50 27.75C50 28.1642 49.6642 28.5 49.25 28.5H18.75C18.3358 28.5 18 28.1642 18 27.75C18 27.3358 18.3358 27 18.75 27H49.25C49.6642 27 50 27.3358 50 27.75Z"
            fill="#ACBDD3"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M62 32.25C62 32.6642 61.6642 33 61.25 33H18.75C18.3358 33 18 32.6642 18 32.25C18 31.8358 18.3358 31.5 18.75 31.5H61.25C61.6642 31.5 62 31.8358 62 32.25Z"
            fill="#ACBDD3"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M38 36.75C38 37.1642 37.6642 37.5 37.25 37.5H18.75C18.3358 37.5 18 37.1642 18 36.75C18 36.3358 18.3358 36 18.75 36H37.25C37.6642 36 38 36.3358 38 36.75Z"
            fill="#ACBDD3"
          />
        </g>
        <g clipPath="url(#clip2_60810_153580)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M62 14.75C62 15.1642 61.6642 15.5 61.25 15.5H18.75C18.3358 15.5 18 15.1642 18 14.75C18 14.3358 18.3358 14 18.75 14H61.25C61.6642 14 62 14.3358 62 14.75Z"
            fill="#ACBDD3"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M50 19.25C50 19.6642 49.6642 20 49.25 20H18.75C18.3358 20 18 19.6642 18 19.25C18 18.8358 18.3358 18.5 18.75 18.5H49.25C49.6642 18.5 50 18.8358 50 19.25Z"
            fill="#ACBDD3"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_60810_153580">
          <rect width="80" height="80" fill="white" />
        </clipPath>
        <clipPath id="clip1_60810_153580">
          <rect
            width="44"
            height="10.5"
            fill="white"
            transform="translate(18 27)"
          />
        </clipPath>
        <clipPath id="clip2_60810_153580">
          <rect
            width="44"
            height="6"
            fill="white"
            transform="translate(18 14)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
